import React from 'react';
import Select from 'react-select';

import { SearchSelectContainer } from './styles';

export function SearchSelect({
  isClearable,
  isSearchable,
  options,
  onChange,
  onInputChange,
  value,
  placeholder,
  onMenuClose,
  className,
  width,
  isDisabled,
  defaultInputValue,
}) {
  return (
    <SearchSelectContainer width={width}>
      <Select
        isDisabled={isDisabled}
        isClearable={isClearable}
        isSearchable={isSearchable}
        options={options}
        onChange={onChange}
        onInputChange={onInputChange}
        defaultInputValue={defaultInputValue}
        value={value}
        placeholder={placeholder}
        onMenuClose={onMenuClose}
        style={{ width: '100%' }}
        className={className}
        isOptionSelected={(option) =>
          option._id ? String(option._id) === String(value._id) : String(option.value) === String(value)
        }
        getOptionLabel={(e) => (
          <>
            {e.icon ? e.icon : ''}
            {e.label}
          </>
        )}
      />
    </SearchSelectContainer>
  );
}
